<template>
  <div class="activity-assign">
    <div v-if="activityType === 2" class="gap-bottom">

      <div class="items-block" v-for="(item, index) in activityFormData" :key="item.Id">
        <div class="items-checkbox">
          <van-checkbox v-model="activityFormData[index].checked">{{ item.title }}</van-checkbox>
        </div>
        <div class="items-group">
          <van-field label="参与人数" input-align="right">
            <template #input>
              <van-stepper :disabled="!activityFormData[index].checked" v-model="activityFormData[index].num" />
            </template>
          </van-field>
        </div>
      </div>
    </div>

    <van-cell-group>
      <template v-if="activityType === 1">
        <van-field label="参与人数" input-align="right">
          <template #input>
            <van-stepper v-model="mainNum" />
          </template>
        </van-field>
      </template>

      <van-field v-model="name" label="联系人" placeholder="请输入姓名" />
      <van-field v-model="phone" label="联系方式" maxlength="11" placeholder="请输入手机号" />
    </van-cell-group>

    <div class="submit-box">
      <van-button type="primary" :disabled="submiting" block @click="submitData">提交报名</van-button>
    </div>
  </div>
</template>

<script>
import { BridgeNativeMethods } from "@/assets/js/jsbridge";
import { activityDetailItemsAPI, activitySubmitAPI } from "@/api/activity";
import { checkResponse } from "@/assets/js/utils";
import debounce from "lodash.debounce";
import { Stepper, Checkbox, CheckboxGroup } from "vant";
import { regexPhone } from '@/assets/js/regex'

export default {
  name: "ActivityAssign",
  components: {
    [Stepper.name]: Stepper,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup
  },
  data() {
    return {
      activityId: null,
      name: "",
      phone: "",
      submiting: false,
      activityFormData: [],
      mainNum: 1,
      activityType: 1 // 1 无子活动 2 children
    };
  },
  mounted() {
    this.debouncedClick = debounce(this.submitData, 500);
    this.activityId = parseInt(this.$route.params.id);
    BridgeNativeMethods.setTitle("报名参加");
    BridgeNativeMethods.getUserInfo((res) => {
      console.log(res)
      if (res.code == 0) {
        let data = res.data;
        this.name = data.realName;
        this.phone = data.mobile;
      }
    });
    this.requestData();
  },
  unmounted() {
    this.debouncedClick.cancel();
  },
  methods: {
    requestData() {
      activityDetailItemsAPI(this.activityId).then(
        (response) => {
          console.log(response);
          if (checkResponse(response)) {
            if (response.data !== null) {

              if (response.data.length == 0) {
                // 无子活动
                this.activityType = 1
              } else {
                this.activityType = 2;

                response.data.forEach((element, index) => {
                  this.$set(this.activityFormData, index, { Id: element.Id, num: 1, checked: false, title: element.title })
                });
              }
            }
          } else {
            BridgeNativeMethods.showToast(response.message);
          }
        },
        (err) => {
          BridgeNativeMethods.showToast("请求错误");
          console.log(err);
        }
      );
    },
    submitData() {
      console.log(this.activityFormData);

     

      if (this.activityFormData.length == 0 && this.activityType == 2) {
        BridgeNativeMethods.showToast("至少选择1个项目");
        return;
      }

      if (this.name == '' || this.name == undefined) {
        BridgeNativeMethods.showToast("请输入姓名");
        return;
      }

      if (this.phone == '') {
        BridgeNativeMethods.showToast("请输入手机号码");
        return;
      }

      if (!regexPhone.test(this.phone)) {
        BridgeNativeMethods.showToast("请输入正确的手机号码");
        return;
      }

      this.submiting = true;
      let params = {
        contacts: this.name,
        mobile: this.phone,
        mainId: this.activityId
      }
      // 无子活动
      if (this.activityType === 1) {
        params.items = []
        params.mainNum = this.mainNum
      } else {
        let items = []
        this.activityFormData.forEach(item => {
          if (item.checked) {
            items.push({
              Id: item.Id,
              num: item.num
            })
          }
        })
        params.items = items
      }
      console.info(params)
      activitySubmitAPI(params).then(
        (response) => {
          console.log(response);
          if (checkResponse(response)) {
            this.$router.replace({ name: 'Result', params: { type: 'activity', extra: JSON.stringify({ Id: response.data.Id }) } })
          } else {
            this.submiting = false;
            BridgeNativeMethods.showToast(response.message);
          }
        },
        (err) => {
          this.submiting = false;
          BridgeNativeMethods.showToast("请求错误");
          console.log(err);
        }
      );
    },
  },
};
</script>

<style scoped lang="less">
.activity-assign {
  padding-top: 16px;
  box-sizing: border-box;
  height: 100vh;
  overflow: auto;
}

.items {
  &-block {
    background: #fff;
  }

  &-group {
    position: relative;
    margin-left: 40px;

    &:after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 16px;
      bottom: 0;
      border-bottom: 1px solid #EEEEEE;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }

  }

  &-checkbox {
    height: 48px;
    display: flex;
    align-items: center;
    margin-left: 16px;
    position: relative;

    &:after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 16px;
      bottom: 0;
      left: 16px;
      border-bottom: 1px solid #EEEEEE;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
  }
}

.submit-box {
  position: fixed;
  bottom: 0;
  left: 16px;
  right: 16px;
  bottom: 8px;
}
</style>